import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    createInstallations,
    deleteInstallations,
    fetchAllInstallations,
    fetchInstallationsWithoutPaggination,
    updateInstallations
} from "../components/Installations/installationsApi";
import {displayNotification} from "./notification";

const initialState = {
    installationsItem: [],
    allInstallations: [],
    isLoading: false,
    creatingInstallations: false,
    modalVisible: false,
    deleteConfirmation: false,
    showMessage: false,
    textMessage: "",
    editInstallation: {},
    isUpdate: false,
    idModal: undefined,
    appLoader: false,
    alarmsLoader: false,
    pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
    }
}

export const getInstallationsWithoutPag = createAsyncThunk(
    'api/installations/all',
    async () => {
        try {
            const response = await fetchInstallationsWithoutPaggination();
            return response.data
        } catch (err) {
            return Promise.reject();
        }
    }
)

export const getAllInstallations = createAsyncThunk(
    '/installations/fetch',
    async ({page = 0, pageSize = 8, searchVal = ""}) => {
        try {
            const response = await fetchAllInstallations(page, pageSize, searchVal)
            return response.data
        } catch (err) {
            return Promise.reject();
        }
    }
)


export const createNewInstallation = createAsyncThunk(
    '/installations/create',
    async (data, {dispatch}) => {
        const response = await createInstallations(data);
        dispatch(getAllInstallations({}))
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Kreirano",
            title: "Kreiranje instalacija"
        }))
        return response.data;
    }
)

export const deleteInstallation = createAsyncThunk(
    '/installations/delete',
    async (id, {dispatch}) => {
        const response = await deleteInstallations(id);
        dispatch(getAllInstallations({}))
        dispatch(displayNotification({notificationStatus: "error", message: "Obrisano", title: "Brisanje instalacija"}))
        return response.data;
    }
)

export const updateInstallationItem = createAsyncThunk(
    'installations/put',
    async ({id, data}, {dispatch}) => {
        const response = await updateInstallations(data, id);
        dispatch(getAllInstallations({}))
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Instalacija uspješno ažurirana.",
            title: "Ažuriranje instalacija"
        }))
        return response.data;
    }
)

export const installationsData = createSlice({
    name: "installations",
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.modalVisible = true;
            state.showMessage = false
        },
        hideModal: (state, action) => {
            state.modalVisible = false
            state.isUpdate = false
            state.showMessage = true
            state.editInstallation = {}
        },
        updateItem: (state, action) => {
            state.editInstallation = action.payload
            state.isUpdate = true
        },
        openDeleteModal: (state, action) => {
            state.deleteConfirmation = true;
            state.idModal = action.payload
        },
        closeDeleteModal: (state) => {
            state.deleteConfirmation = false;
        },
        clearInstallations: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(getAllInstallations.pending, (state) => {
                state.installationsItem = [];
                state.isLoading = true;
                state.appLoader = true;
            })
            .addCase(getAllInstallations.rejected, (state, action) => {
                state.isLoading = false;
                state.installationsItem = [];
                state.appLoader = false;
            })
            .addCase(getAllInstallations.fulfilled, (state, action) => {
                const {content, totalElements, size, number} = action.payload;
                state.isLoading = false;
                state.installationsItem = content;
                state.appLoader = false;
                state.pagination.total = totalElements;
                state.pagination.pageSize = size;
                state.pagination.currentPage = number;
            })
            .addCase(createNewInstallation.pending, state => {
                state.creatingInstallations = true
                state.modalVisible = false
                state.isUpdate = false
            })
            .addCase(createNewInstallation.rejected, state => {
                state.creatingInstallations = false
                state.modalVisible = false
                state.isUpdate = false
            })
            .addCase(createNewInstallation.fulfilled, (state, action) => {
                state.creatingInstallations = true
                state.modalVisible = false
                state.isUpdate = false
            })
            .addCase(deleteInstallation.pending, state => {
                state.deleteConfirmation = true
            })
            .addCase(deleteInstallation.rejected, state => {
                state.deleteConfirmation = false
            })
            .addCase(deleteInstallation.fulfilled, (state, action) => {
                state.deleteConfirmation = false
            })
            .addCase(updateInstallationItem.pending, (state, action) => {
                state.modalVisible = true
                state.isUpdate = true
            })
            .addCase(updateInstallationItem.rejected, state => {
                state.modalVisible = false
                state.isUpdate = false
            })
            .addCase(updateInstallationItem.fulfilled, (state) => {
                state.modalVisible = false
                state.isUpdate = false
                state.editInstallation = {}
            })
            .addCase(getInstallationsWithoutPag.pending, state => {
                state.isLoading = true;
                state.appLoader = true;
            })
            .addCase(getInstallationsWithoutPag.rejected, (state, action) => {
                state.isLoading = false;
                state.allInstallations = [];
                state.appLoader = false;
            })
            .addCase(getInstallationsWithoutPag.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allInstallations = action.payload;
                state.appLoader = false;
            })
    }
})

export const {
    openModal,
    hideModal,
    updateItem,
    openDeleteModal,
    closeDeleteModal,
    clearInstallations
} = installationsData.actions
export default installationsData.reducer;
